export const checkIsNoData = (...data) => {
  return data.every(
    datum =>
      datum === 0 ||
      datum === '0' ||
      datum === '0.0' ||
      datum === '0.00' ||
      datum === null ||
      datum === undefined
  )
}
export default checkIsNoData
